
  import activity from '~/mixins/pages/mission-control/activity'
  export default {
    mixins: [activity],
    data() {
      return {
        setIndex: 0
      }
    },
    watch: {
      setIndex() {
        this.$nextTick(this.updateIndicator)
      },
      '$route.query.mission_type'(value) {
        this.setActive(parseInt(value))
      }
    },
    mounted() {
      this.$nextTick(this.updateIndicator)
      window.addEventListener('resize', this.updateIndicator)
      if (this.$route.query.mission_type) {
        this.setActive(parseInt(this.$route.query.mission_type))
      }
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.updateIndicator)
    },
    methods: {
      setActive(index) {
        this.setIndex = index
        this.$nextTick(this.updateIndicator)
      },
      updateIndicator() {
        const buttons = this.$refs.actionBtn
        const indicator = this.$refs.activeIndicator
        if (!buttons || !indicator) return
        // If only one button, $refs returns single Node, otherwise array
        const activeBtn = Array.isArray(buttons) ? buttons[this.setIndex] : buttons
        if (!activeBtn) return
        indicator.style.left = activeBtn.offsetLeft + 'px'
        indicator.style.width = activeBtn.offsetWidth + 'px'
      }
    }
  }
